import { View, type ViewStyle } from 'react-native'
import { type ReactNode } from 'react'
import { useResponsive } from '../hooks/useResponsive'

interface ContentContainerProps {
  children: ReactNode
  style?: ViewStyle
  maxWidth?: number
}

export default function ContentContainer({ children, style, maxWidth = 1280 }: ContentContainerProps) {
  const { isDesktop } = useResponsive()

  return (
    <View
      style={[
        { flex: 1 },
        isDesktop && { maxWidth, width: '100%' as any, alignSelf: 'center' as const },
        style,
      ]}
    >
      {children}
    </View>
  )
}
